import type { BaseUserState, OktaUser } from '~/types/tShared';

export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_USER_NOTIFICATION_PREFERENCES = 'GET_USER_NOTIFICATION_PREFERENCES';
export const UPDATE_USER_NOTIFICATION_PREFERENCE = 'UPDATE_USER_NOTIFICATION_PREFERENCE';

interface GetCurrentUserAction {
  type: typeof GET_CURRENT_USER;
}

export interface GetUserNotificationPreferencesAction {
  type: typeof GET_USER_NOTIFICATION_PREFERENCES;
}

export interface UpdateUserNotificationPreferenceAction {
  type: typeof UPDATE_USER_NOTIFICATION_PREFERENCE;
  notificationPreference: UserNotificationPreference;
}

export type EnhancedUserActionTypes = GetCurrentUserAction;

export interface UserNotificationPreference {
  templateType: string;
  institutionId: string;
  queuedSendDate?: string | null;
  intendedSendDate: string;
  commMethod: string;
  notificationOn: boolean;
}

export interface UserNotificationPreferenceSection {
  title: string;
  notifications: UserNotificationPreference[];
}

export type BaseUserStateWithFeatures = BaseUserState & {
  user: {
    features: string[];
    notificationPreferences: UserNotificationPreferenceSection[];
  } & OktaUser;
};
